import { CLASSES, SETTINGS } from '../../utils/constants';

/** DOM attribute string values (Sonar: avoid duplicate literals). */
const ATTR_TRUE = 'true';
const ATTR_FALSE = 'false';
const ATTR_ARIA_EXPANDED = 'aria-expanded';
const DATA_MOBILE_NAV_OPEN = 'data-mobile-nav-open';
const DATA_TOGGLE_NAME = 'data-toggle-name';
const PREFIX_TOGGLE = 'toggle-';
const PREFIX_MENU = 'menu-';

function toggleOverflow(isOpen) {
  if (isOpen) {
    document.body.classList.add(CLASSES.OVERFLOW_HIDDEN);
  } else {
    document.body.classList.remove(CLASSES.OVERFLOW_HIDDEN);
  }
}

const initNavigation = () => {
  
  const desktopNavigation = document.querySelector('[data-navigation-desktop]');
  const mobileNavigation = document.querySelector('[data-nav-mobile-menu]');
  const toggleMobileNavigation = document.querySelectorAll('[data-nav-mobile-toggle]');

  const subMenuToggle = document.querySelectorAll('[data-submenu-toggle]');
  const subMenuBack = document.querySelectorAll('[data-submenu-back]');

  const subMenus = document.querySelectorAll('[data-submenu]');

  const mobileNavBackdrop = document.querySelector('[data-nav-mobile-backdrop]');

  let mobileNavCloseTimer = null;

  const clearMobileNavCloseTimer = () => {
    if (mobileNavCloseTimer) {
      window.clearTimeout(mobileNavCloseTimer);
      mobileNavCloseTimer = null;
    }
  };

  const finishMobileNavClose = () => {
    clearMobileNavCloseTimer();
    document.body.removeAttribute(DATA_MOBILE_NAV_OPEN);
    toggleOverflow(false);
  };

  const setMobileNavOpen = (open) => {
    if (!mobileNavigation) return;

    if (open) {
      clearMobileNavCloseTimer();
      mobileNavigation.classList.remove(CLASSES.TRANSLATE_X_100);
      mobileNavigation.setAttribute('open', ATTR_TRUE);
      document.body.setAttribute(DATA_MOBILE_NAV_OPEN, '');
      toggleMobileNavigation.forEach((b) => {
        b.setAttribute(ATTR_ARIA_EXPANDED, ATTR_TRUE);
      });
      toggleOverflow(true);
      return;
    }

    mobileNavigation.classList.add(CLASSES.TRANSLATE_X_100);
    mobileNavigation.removeAttribute('open');
    subMenus.forEach((submenu) => {
      submenu.classList.add('hidden');
    });
    toggleMobileNavigation.forEach((b) => {
      b.setAttribute(ATTR_ARIA_EXPANDED, ATTR_FALSE);
    });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      finishMobileNavClose();
      return;
    }

    clearMobileNavCloseTimer();
    mobileNavCloseTimer = window.setTimeout(
      finishMobileNavClose,
      SETTINGS.FILTER_DRAW_ANIMATION_TIME
    );
  };

  if (mobileNavigation && toggleMobileNavigation.length) {
    toggleMobileNavigation.forEach((btn) => {
      btn.addEventListener('click', () => {
        const isOpen = !mobileNavigation.classList.contains(CLASSES.TRANSLATE_X_100);
        setMobileNavOpen(!isOpen);
      });
    });

    mobileNavBackdrop?.addEventListener('click', () => {
      if (!mobileNavigation.classList.contains(CLASSES.TRANSLATE_X_100)) {
        setMobileNavOpen(false);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (
        e.key === 'Escape' &&
        !mobileNavigation.classList.contains(CLASSES.TRANSLATE_X_100)
      ) {
        setMobileNavOpen(false);
      }
    });
  }

  if (desktopNavigation) {
    desktopNavigation.addEventListener('mouseenter', () => {
      desktopNavigation.setAttribute('open', true);
    });

    desktopNavigation.addEventListener('mouseleave', () => {
      desktopNavigation.removeAttribute('open');
    });
  }

  const resolveSubmenu = toggle => {
    const toggleName = toggle.getAttribute(DATA_TOGGLE_NAME);
    if (!toggleName) return toggle.nextElementSibling;

    const menuName = toggleName.startsWith(PREFIX_TOGGLE)
      ? PREFIX_MENU + toggleName.slice(PREFIX_TOGGLE.length)
      : toggleName;
    const root = toggle.closest('[data-nav-mobile-menu]');
    const escaped =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(menuName) : menuName;
    return root?.querySelector(`[data-submenu][data-menu-name="${escaped}"]`) || toggle.nextElementSibling;
  };

  subMenuToggle.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const submenu = resolveSubmenu(toggle);
      if (!submenu?.classList) return;

      const opening = submenu.classList.contains('hidden');
      if (opening) {
        const tierParent = submenu.parentElement;
        tierParent?.querySelectorAll(':scope > [data-submenu]').forEach(panel => {
          if (panel !== submenu) panel.classList.add('hidden');
        });
        tierParent?.querySelectorAll(`[${DATA_TOGGLE_NAME}]`).forEach(t => {
          if (resolveSubmenu(t) !== submenu) {
            t.setAttribute(ATTR_ARIA_EXPANDED, ATTR_FALSE);
          }
        });
      }

      submenu.classList.toggle('hidden');
      toggle.setAttribute(ATTR_ARIA_EXPANDED, submenu.classList.contains('hidden') ? ATTR_FALSE : ATTR_TRUE);
    });
  });

  subMenuBack.forEach((back) => {
    back.addEventListener('click', () => {
      const submenu = back.closest('[data-submenu]');
      if (!submenu) return;

      submenu.classList.add('hidden');

      const menuKey = submenu.dataset.menuName;
      if (!menuKey) return;

      const toggleName = menuKey.startsWith(PREFIX_MENU)
        ? PREFIX_TOGGLE + menuKey.slice(PREFIX_MENU.length)
        : menuKey;
      const toggle = document.querySelector(`[data-toggle-name="${toggleName}"]`);
      if (toggle) {
        toggle.setAttribute(ATTR_ARIA_EXPANDED, ATTR_FALSE);
      }
    });
  });

};
  
export default initNavigation;